module.exports = __webpack_public_path__ + "img/cloth_g3_item-05.11d0a3b4.svg";